import { useCallback, useMemo, useState } from 'react';

import { mergeFilterUpdate } from '#/modules/commonComponents/table/listFilterKeys';

const DEFAULT_PAGE_SIZE = 10;

/**
 * 成品候選 Dialog 本地 listQuery（不寫 URL）。
 */
function useWorkOrderMaterialCandidateListQuery() {
  const [page, setPageState] = useState(1);
  const [pageSize, setPageSizeState] = useState(DEFAULT_PAGE_SIZE);
  const [keyword, setKeywordState] = useState('');
  const [sort, setSortState] = useState([]);
  const [filters, setFiltersState] = useState({});

  const listQuery = useMemo(() => ({
    page,
    pageSize,
    keyword,
    sort,
    filters,
  }), [page, pageSize, keyword, sort, filters]);

  const setPage = useCallback((nextPage) => {
    setPageState(nextPage);
  }, []);

  const setPageSize = useCallback((nextPageSize) => {
    setPageSizeState(nextPageSize);
    setPageState(1);
  }, []);

  const setKeyword = useCallback((nextKeyword) => {
    setKeywordState(nextKeyword ?? '');
    setPageState(1);
  }, []);

  const setFilter = useCallback((key, value) => {
    setFiltersState((prev) => mergeFilterUpdate(prev, key, value));
    setPageState(1);
  }, []);

  const setSort = useCallback((nextSort) => {
    setSortState(nextSort ?? []);
    setPageState(1);
  }, []);

  const removeSortAt = useCallback((index) => {
    setSortState((prev) => (prev ?? []).filter((_, sortIndex) => sortIndex !== index));
  }, []);

  const resetQuery = useCallback(() => {
    setPageState(1);
    setPageSizeState(DEFAULT_PAGE_SIZE);
    setKeywordState('');
    setSortState([]);
    setFiltersState({});
  }, []);

  return {
    listQuery,
    setPage,
    setPageSize,
    setKeyword,
    setFilter,
    setSort,
    removeSortAt,
    resetQuery,
  };
}

export default useWorkOrderMaterialCandidateListQuery;
